module.exports = __webpack_public_path__ + "img/message-question.9c5795af.svg";